import { Card, CardContent } from "@/components/ui/card"
import { kpis, categories, prescriptionsOverTime } from "../-data/fixtures"
import { ChartContainer, ChartLegend, ChartLegendContent } from "@/components/ui/chart"
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts"

export default function FilledPrescriptions() {
  return (
    <Card className="rounded-2xl">
      <CardContent className="p-4">
        <div className="flex items-center">
          <div>
            <div className="text-xs text-muted-foreground">Filled prescriptions</div>
            <div className="text-2xl font-semibold flex items-center gap-2">
              {kpis.filledPrescriptions.total.toLocaleString()}
              <span className="text-green-600 text-xs">↗ {kpis.filledPrescriptions.deltaPct}%</span>
            </div>
          </div>
        </div>
        <div className="mt-3 space-y-1">
          {categories.filledBreakdown.map((c, i) => (
            <div key={i} className="flex items-center justify-between text-sm">
              <span>{c.label}</span>
              <div className="flex items-center gap-2">
                <span className="tabular-nums">AED {c.value.toFixed(2)}</span>
                <span className={`${c.deltaPct >= 0 ? "text-green-600" : "text-red-600"} text-xs`}>
                  {c.deltaPct >= 0 ? "↗" : "↘"} {Math.abs(c.deltaPct)}%
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-3">
          <div className="text-sm text-black mb-1">Prescriptions over time</div>
          <ChartContainer
            config={{ inPerson: { label: "In-Person", color: "#e16a52" }, online: { label: "Online", color: "#2aa198" } }}
            className="w-full h-64 aspect-auto"
          >
            <BarChart data={prescriptionsOverTime}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="month" tickLine={false} axisLine={false} />
              <YAxis hide />
              <Bar dataKey="inPerson" fill="var(--color-inPerson)" radius={[4, 4, 0, 0]} />
              <Bar dataKey="online" fill="var(--color-online)" radius={[4, 4, 0, 0]} />
              <ChartLegend content={<ChartLegendContent />} />
            </BarChart>
          </ChartContainer>
        </div>
      </CardContent>
    </Card>
  )
}